import { render } from "./RichMenuSelector.vue?vue&type=template&id=362fcb32&scoped=true"
import script from "./RichMenuSelector.vue?vue&type=script&lang=ts"
export * from "./RichMenuSelector.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-362fcb32"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QImg,QMenu,QList,QItem,QItemSection,QSpace});qInstall(script, 'directives', {ClosePopup});
